import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { GetFactors, GetAuthVersionByOrgId, GetFactorsByOrgId } from './service';
import Api from './api/main';
/**  本地缓存key  */

var YXT_FACTORS = 'yxt_factors';
var OLD_FACTORS_DATA = 'yxt_old_factors_data';
window.__functCodePadding = null;
window.__functCodeVersion = null;
window.__functCodeVersionPadding = null;
window.__functCode = null;
export var install = function install(config) {
  if (config === void 0) {
    config = {};
  }

  // 设置域名
  if (config.env || config.domain) {
    Api.setConfig(config);
  }
};
/**
 * 将入参转成数组格式
 * @param params 
 * @returns 
 */

var preHandleParams = function preHandleParams(params) {
  var codes = [];
  var isArray = Object.prototype.toString.call(params) === '[object Array]';

  if (params) {
    if (typeof params === 'object') {
      if (isArray) {
        codes = params;
      } else {
        codes = Object.values(params);
      }
    } else if (typeof params === 'string') {
      codes.push(params);
    }
  }

  return codes;
};

var flattenData = function flattenData(target) {
  // 数组扁平化
  var arr = [];
  target.forEach(function (item) {
    arr.push(item);

    if (item.functions && item.functions.length) {
      item.functions.forEach(function (ctrl) {
        ctrl.globalState = item.globalState;
        ctrl.orgState = item.orgState;
        arr.push(ctrl);
      });
    }
  });
  return arr;
};

var filterData = function filterData(target) {
  // 删除要素中的无用属性
  return target.map(function (item) {
    if (item.functions) {
      delete item.functions;
    }

    return item;
  });
};

var filterObj = function filterObj(target) {
  // 重新定义状态
  var obj = {};
  var EnumBuyState = {
    1: {
      // 启用
      '-1': 'noBuy',
      // 未购买
      '0': 'timeout',
      // 购买已过期
      '1': 'bought' // 购买未过期

    },
    0: {
      // 禁用
      '-1': 'none',
      '0': 'none',
      '1': 'none'
    }
  };
  var EnumPointState = {
    'none': 0,
    // 要素下架-隐藏
    'noBuy': 1,
    // 要素上架-未购买-隐藏
    'bought': {
      // 购买未过期 - 走启用逻辑（enableCtrlType）
      0: 2,
      // 显示
      1: 3,
      // 隐藏
      2: 4 // 自定义

    },
    'timeout': {
      // 购买已过期 - 走禁用逻辑（forbidCtrlType）
      0: 5,
      // 隐藏
      1: 6,
      // 置灰
      2: 7 // 自定义

    }
  };
  target.forEach(function (item) {
    // 注意，这样子判断，如果要素和功能点code相同，只会展示功能点的状态，不会出现类似support_center: 1, 这样子的数据
    if (item.funcCode) {
      var factorState = EnumBuyState[item.globalState][item.orgState];
      obj[item.funcCode] = {
        orgState: item.orgState,
        globalState: item.globalState,
        forbidCtrlType: item.forbidCtrlType,
        enableCtrlType: item.enableCtrlType
      };

      switch (factorState) {
        case 'none':
          obj[item.funcCode].webState = 0;
          break;

        case 'noBuy':
          obj[item.funcCode].webState = 1;
          break;

        case 'timeout':
          obj[item.funcCode].webState = EnumPointState['timeout'][item.forbidCtrlType];
          break;

        case 'bought':
          obj[item.funcCode].webState = EnumPointState['bought'][item.enableCtrlType];
          break;

        default:
          break;
      }
    } else if (item.factorCode) {
      obj[item.factorCode] = item.globalState;
    }
  });
  return obj;
};
/**
 * 过滤数组,只返回本次请求的功能点和对应的要素
 * @param funcCodes 
 * @returns 
 */


var filterFactorList = function filterFactorList(allList, funcCodes) {
  if (allList === void 0) {
    allList = [];
  }

  if (funcCodes === void 0) {
    funcCodes = [];
  }

  var filterData = [];
  allList.forEach(function (item) {
    var newItem = {
      factorCode: item.factorCode,
      globalState: item.globalState,
      orgState: item.orgState,
      functions: []
    };
    item.functions && item.functions.forEach(function (funItem) {
      if (funcCodes.includes(funItem.funcCode)) {
        newItem.functions.push(funItem);
      }
    });

    if (newItem.functions.length) {
      filterData.push(newItem);
    }
  });
  return filterData;
};
/**
 * 
 * @returns 
 */


var asyncAjaxCode = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var orgId, getFactorFlag, oldFactorVersion, versionData, oldFactorList, datas;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            orgId = window.localStorage.getItem('orgId');

            if (orgId) {
              _context.next = 4;
              break;
            }

            console.warn('ajaxCode 没有获取到 orgId');
            return _context.abrupt("return", []);

          case 4:
            getFactorFlag = false; // 是否调用要素接口

            if (!(window.__functCodeVersion && window.__functCode)) {
              _context.next = 11;
              break;
            }

            // window上有版本号和要素code，并且缓存里有要素的数据缓存里的数据
            window.__functCode = window.__functCode;
            window.sessionStorage.setItem(OLD_FACTORS_DATA, JSON.stringify(window.__functCode)); // 存储原始数据

            return _context.abrupt("return", window.__functCode);

          case 11:
            oldFactorVersion = Number(window.localStorage.getItem('factorVersion'));

            if (window.__functCodeVersion) {
              _context.next = 45;
              break;
            }

            // 没有要素版本号，则先获取要素版本号
            // 获取当前版本号
            if (!window.__functCodeVersionPadding) {
              window.__functCodeVersionPadding = GetAuthVersionByOrgId(orgId).catch(function () {
                return null;
              });
            }

            _context.prev = 14;
            _context.next = 17;
            return window.__functCodeVersionPadding;

          case 17:
            versionData = _context.sent;
            window.__functCodeVersion = versionData.lastUpdate;
            oldFactorList = JSON.parse(window.localStorage.getItem(OLD_FACTORS_DATA) || '[]');

            if (!(oldFactorVersion !== versionData.lastUpdate)) {
              _context.next = 25;
              break;
            }

            // 要素版本号已经更新
            window.localStorage.setItem('factorVersion', versionData.lastUpdate);
            getFactorFlag = true;
            _context.next = 37;
            break;

          case 25:
            if (!(oldFactorVersion === versionData.lastUpdate && oldFactorList.length)) {
              _context.next = 31;
              break;
            }

            // 要素版本号未更新并且缓存中有要素
            window.__functCode = oldFactorList;
            window.sessionStorage.setItem(OLD_FACTORS_DATA, JSON.stringify(oldFactorList)); // 存储原始数据

            return _context.abrupt("return", oldFactorList);

          case 31:
            if (!window.__functCode) {
              _context.next = 36;
              break;
            }

            window.sessionStorage.setItem(OLD_FACTORS_DATA, JSON.stringify(window.__functCode)); // 存储原始数据

            return _context.abrupt("return", window.__functCode);

          case 36:
            getFactorFlag = true;

          case 37:
            _context.next = 43;
            break;

          case 39:
            _context.prev = 39;
            _context.t0 = _context["catch"](14);
            console.warn('获取版本号接口报错', JSON.stringify(_context.t0));
            getFactorFlag = true;

          case 43:
            _context.next = 50;
            break;

          case 45:
            if (!window.__functCode) {
              _context.next = 49;
              break;
            }

            return _context.abrupt("return", window.__functCode);

          case 49:
            getFactorFlag = true;

          case 50:
            if (!getFactorFlag) {
              _context.next = 71;
              break;
            }

            // 需要查询要素code
            datas = []; // 获取全量接口数据

            if (!window.__functCodePadding) {
              window.__functCodePadding = GetFactorsByOrgId(orgId).catch(function () {
                return null;
              });
            }

            _context.prev = 53;
            _context.next = 56;
            return window.__functCodePadding;

          case 56:
            datas = _context.sent;

            if (!(!datas || !datas.length)) {
              _context.next = 59;
              break;
            }

            return _context.abrupt("return", []);

          case 59:
            window.__functCode = datas; // 存储新数据

            window.sessionStorage.setItem(OLD_FACTORS_DATA, JSON.stringify(datas)); // 存储原始数据

            window.localStorage.setItem(OLD_FACTORS_DATA, JSON.stringify(datas)); // 存储原始数据

            return _context.abrupt("return", datas);

          case 65:
            _context.prev = 65;
            _context.t1 = _context["catch"](53);
            console.error("要素全量接口接口报错");
            return _context.abrupt("return", []);

          case 69:
            _context.next = 72;
            break;

          case 71:
            console.log("不满足上面条件");

          case 72:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[14, 39], [53, 65]]);
  }));

  return function asyncAjaxCode() {
    return _ref.apply(this, arguments);
  };
}();
/**
 * 根据某个功能点要素获取code
 * @param funcCodes 
 * @param factorCodes 
 * @returns 
 */


var ajaxCode = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(funcCodes, factorCodes) {
    var orgId, datas;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            orgId = window.localStorage.getItem('orgId');

            if (orgId) {
              _context2.next = 4;
              break;
            }

            console.warn('ajaxCode 没有获取到 orgId');
            return _context2.abrupt("return", []);

          case 4:
            _context2.next = 6;
            return GetFactors(orgId, funcCodes, factorCodes).catch(function () {
              return null;
            });

          case 6:
            datas = _context2.sent;

            if (!(!datas || !datas.length)) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return", []);

          case 9:
            return _context2.abrupt("return", datas);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function ajaxCode(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

var dealData = function dealData(datas) {
  // 处理数据
  var initData = flattenData(datas); // 原始数据扁平化

  var dealData = filterData(initData).sort(function (a, b) {
    // 删除要素中的functions属性,重新排序 state = 0 排前面
    return a.globalState - b.globalState;
  });
  var changeObj = filterObj(dealData); // 转化成对象类型

  return changeObj;
};
/**
 * 
 * @param list 
 * @returns 
 */


function saveFactorsData(list) {
  var map = {};
  list.forEach(function (e) {
    if (e.factorCode) {
      map[e.factorCode] = e;
    }

    if (e.funcCode) {
      map[e.funcCode] = e;
    }
  });

  var _list = Object.values(map);

  var factorMap = dealData(_list);
  var oldFactorMap = JSON.parse(window.localStorage.getItem(YXT_FACTORS) || '{}');

  var _e = Object.assign({}, oldFactorMap, factorMap);

  window.localStorage.setItem(YXT_FACTORS, JSON.stringify(_e));
  window.sessionStorage.setItem(YXT_FACTORS, JSON.stringify(_e));
  return _e;
}
/**
 * @description: 要素功能点预校验，获取API数据并存储，供之后使用
 * @param {any} code
 * @return {*}
 */


export var preCheckFunctions = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(funcCode) {
    var funcCodes, handleFactor;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            funcCodes = preHandleParams(funcCode); // 功能点

            if (funcCodes.length) {
              _context4.next = 3;
              break;
            }

            return _context4.abrupt("return", null);

          case 3:
            handleFactor = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve, reject) {
                var successFunc, allPointArry, pointArry;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        successFunc = function successFunc(val) {
                          resolve(val);
                        };

                        _context3.prev = 1;
                        _context3.next = 4;
                        return asyncAjaxCode();

                      case 4:
                        allPointArry = _context3.sent;
                        pointArry = filterFactorList(allPointArry, funcCodes);

                        if (pointArry.length) {
                          _context3.next = 8;
                          break;
                        }

                        return _context3.abrupt("return", successFunc({}));

                      case 8:
                        return _context3.abrupt("return", successFunc(saveFactorsData(pointArry)));

                      case 11:
                        _context3.prev = 11;
                        _context3.t0 = _context3["catch"](1);
                        reject(_context3.t0);

                      case 14:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[1, 11]]);
              }));

              return function handleFactor(_x4, _x5) {
                return _ref4.apply(this, arguments);
              };
            }();

            return _context4.abrupt("return", new Promise(handleFactor));

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function preCheckFunctions(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

function mergeFunctions(oldArry, newArry) {
  var _newArry;

  if (oldArry === void 0) {
    oldArry = [];
  }

  if (newArry === void 0) {
    newArry = [];
  }

  if (!((_newArry = newArry) != null && _newArry.length)) return oldArry;
  var arry = [];
  var oldMap = oldArry.reduce(function (cur, it) {
    return cur[it == null ? void 0 : it.funcCode] = it, cur;
  }, {});
  newArry.forEach(function (point) {
    // hack 遗留数据
    if (point != null && point.funcCode) {
      arry.push(point);
      delete oldMap[point.funcCode];
    }
  });
  return arry.concat(Object.values(oldArry));
}

function assignArrayObject(oldPoints, points) {
  var _points;

  if (oldPoints === void 0) {
    oldPoints = [];
  }

  if (points === void 0) {
    points = [];
  }

  if (!((_points = points) != null && _points.length)) return oldPoints;
  var oldPointMap = oldPoints.reduce(function (cur, it) {
    if (it != null && it.factorCode) {
      cur[it.factorCode] = it;
    }

    return cur;
  }, {});
  var newPoints = [];
  points.forEach(function (p) {
    // hack 遗留数据
    if (!p.factorCode) return;
    var oldPoint = oldPointMap[p.factorCode];

    if (!oldPoint) {
      newPoints.push(p);
    } else {
      var orgState = oldPoint.orgState,
          globalState = oldPoint.globalState,
          functions = oldPoint.functions;

      if (orgState === p.orgState && globalState === p.globalState && (functions || p != null && p.functions)) {
        newPoints.push(_extends({}, p, {
          functions: mergeFunctions(functions, p == null ? void 0 : p.functions)
        }));
      } else {
        newPoints.push(p);
      }

      delete oldPointMap[p.factorCode];
    }
  });
  return newPoints.concat(Object.values(oldPointMap));
}
/**
 * 通过要素点获取，此要素下所有功能点源数据
 * @param factorCode 
 * @returns 
 */


function getAllFunctionsByFactorCode(factorCode) {
  try {
    if (!factorCode) return;
    var oldFactorList = JSON.parse(window.localStorage.getItem(OLD_FACTORS_DATA));
    return oldFactorList.find(function (it) {
      return it.factorCode === factorCode;
    });
  } catch (_unused) {
    return;
  }
}

export default {
  install: install,
  preCheckFunctions: preCheckFunctions,
  ajaxCode: ajaxCode,
  dealData: dealData,
  YXT_FACTORS: YXT_FACTORS,
  getAllFunctionsByFactorCode: getAllFunctionsByFactorCode
};